import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-lifestyle")({
  component: lazyRouteComponent(() => import("./-pages/admin.product-lifestyle")),
  head: () => ({ meta: [{ title: "صور Lifestyle للمنتج — Admin" }] }),
});
